var _defs, _title, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 220,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 58.784 21.099 L 150.784 21.099 C 152.993 21.099 154.784 22.89 154.784 25.099 L 154.784 31.667 L 189.784 31.667 C 192.545 31.667 194.784 33.906 194.784 36.667 L 194.784 53.667 C 194.784 56.428 192.545 58.667 189.784 58.667 L 19.784 58.667 C 17.023 58.667 14.784 56.428 14.784 53.667 L 14.784 36.667 C 14.784 33.906 17.023 31.667 19.784 31.667 L 54.784 31.667 L 54.784 25.099 C 54.784 22.89 56.575 21.099 58.784 21.099 Z",
    id: "svg_3",
    stroke: "#000",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 59.863 69.647 L 149.863 69.647 C 158.147 69.647 164.863 76.363 164.863 84.647 L 164.863 188.56 C 164.863 196.844 158.147 203.56 149.863 203.56 L 59.863 203.56 C 51.579 203.56 44.863 196.844 44.863 188.56 L 44.863 84.647 C 44.863 76.363 51.579 69.647 59.863 69.647 Z",
    style: {},
    stroke: "#000\" fill=\"#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150.664 136.399 L 164.133 131.133 L 141.315 147.539 L 118.123 132.003 L 131.965 136.399 L 131.965 129.16 C 130.182 121.816 125.52 115.405 118.891 111.528 C 100.39 100.711 77.263 114.233 77.263 135.867 C 77.263 145.907 82.554 155.185 91.138 160.204 C 103.826 167.623 118.689 163.595 126.777 153.355 L 145.735 158.082 C 141.732 165.606 135.704 172.009 128.142 176.429 C 97.307 194.458 58.762 171.922 58.762 135.867 C 58.762 119.133 67.578 103.67 81.889 95.304 C 110.843 78.375 146.596 97.213 150.849 129.426 L 150.664 129.426 L 150.664 136.399 Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)"
    },
    stroke: "#fff\" fill=\"#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.ab012a643fb723c866343f697d9470c5.svg";
export { ForwardRef as ReactComponent };